// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see DisputesHistoryViewLoadEvent
 */
export var DisputesHistoryViewLoad = function (_a) {
    var status = _a.status, transactionTokens = _a.transactionTokens, flowToken = _a.flowToken, hasMore = _a.hasMore;
    return ({
        name: "DisputesHistory View Load",
        parameters: {
            cdf_entity: "DisputesHistory",
            cdf_action: "View",
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_tokens: transactionTokens !== undefined && transactionTokens !== null ? transactionTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            has_more: hasMore !== undefined && hasMore !== null ? hasMore.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DisputesHistoryViewLoadMoreEvent
 */
export var DisputesHistoryViewLoadMore = function (_a) {
    var status = _a.status, flowToken = _a.flowToken;
    return ({
        name: "DisputesHistory View LoadMore",
        parameters: {
            cdf_entity: "DisputesHistory",
            cdf_action: "View",
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DisputesHistoryViewReachEndEvent
 */
export var DisputesHistoryViewReachEnd = function (_a) {
    var transactionTokens = _a.transactionTokens, flowToken = _a.flowToken;
    return ({
        name: "DisputesHistory View ReachEnd",
        parameters: {
            cdf_entity: "DisputesHistory",
            cdf_action: "View",
            transaction_tokens: transactionTokens !== undefined && transactionTokens !== null ? transactionTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see DisputesHistoryTapOpenReceiptEvent
 */
export var DisputesHistoryTapOpenReceipt = function (_a) {
    var flowToken = _a.flowToken, transactionToken = _a.transactionToken;
    return ({
        name: "DisputesHistory Tap OpenReceipt",
        parameters: {
            cdf_entity: "DisputesHistory",
            cdf_action: "Tap",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            transaction_token: transactionToken !== undefined && transactionToken !== null ? transactionToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
